import { useState, useEffect } from "react";
import Link from "next/link";
import _ from "lodash";
import { isMobile } from "react-device-detect";
import { calcVaildPromoDateWithTimeZone } from "../../utils/app";

export default (props) => {
  const [fixedPromos, setFixedPromos] = useState([]);
  const [randomPromos, setRandomPromos] = useState([]);

  useEffect(() => {
    const promoValidator = (p) => {
      const today = new Date();
      const { startDate, endDate } = calcVaildPromoDateWithTimeZone(p);
      return p.kind === "post" && today > startDate && today < endDate;
    };

    if (props.promos) {
      const fixedPromos = props.promos.filter(
        (p) => p.position === 0 && promoValidator(p)
      );
      setFixedPromos(fixedPromos);
      const randomPromos = props.promos.filter(
        (p) => p.position !== 0 && promoValidator(p)
      );
      setRandomPromos(
        _.sampleSize(randomPromos, fixedPromos.length === 0 ? 2 : 1)
      );
    }
  }, [props.promos]);

  const renderPromo = (promo) => (
    <div key={promo.id} className={`promo-item promo-type-${promo.kind}`}>
      <Link legacyBehavior href="/promos/[id]" as={`/promos/${promo.id}`}>
        <a
          id={`promo_${promo.id}`}
          title={promo.title}
          target="_blank"
          rel={`noopener noreferrer ${promo.follow ? "" : "nofollow"}`}>
          {isMobile ? (
            <img src={promo.image_500x120_url} alt={promo.title} />
          ) : (
            <img src={promo.image_800x100_url} alt={promo.title} />
          )}
        </a>
      </Link>
    </div>
  );

  return (
    <div>
      {fixedPromos.map(renderPromo)}
      {randomPromos.map(renderPromo)}
    </div>
  );
};
